import Vue from 'vue';
import Router from 'vue-router';
import routes from './constants/routes';
import { middlewarePipeline } from './utils/routerMiddleware';
import store from './store';

Vue.use(Router);

const router = new Router({
  mode: process.env.CORDOVA_PLATFORM ? 'hash' : 'history',
  routes
});

router.beforeEach((to, from, next) => {
  const { middleware } = to.meta;

  if (!middleware) return next();

  const context = {
    to,
    from,
    next,
    store
  };

  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  });
});


export default router;
